module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"privacy-policy":"Privacy Policy","terms-of-use":"Terms of Use","feedback-form":"Send Feedback"},"ja":{"privacy-policy":"プライバシーポリシー","terms-of-use":"利用規約","feedback-form":"フィードバックを送信"}}')
  delete Component.options._Ctor
}
